// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sgf-ace .has-golf-id-view__layout[data-v-12d3f7d6]{display:grid;grid-template-columns:minmax(0,1fr);gap:16px}.sgf-ace .has-golf-id-view__layout__main-form[data-v-12d3f7d6]{display:grid;grid-template-columns:minmax(0,max-content) minmax(0,1fr);gap:16px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
